export default __webpack_public_path__ + "static/media/14.f714ba5e.jpg";